module.exports = __webpack_public_path__ + "media/images/athletes/1632-8af44ac4e4360b1cc09ca47da3317016.png";